import axios from 'axios';
import { property } from 'lodash';

import { SURVEY_COMMON_TYPE } from 'constants/SurveyTypes';
import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';

import { mapTemplateDataForEditor } from './dataMapper/mapTemplateDataFromApi';
import { mapSurveyFromJsonApiModel } from '../dataMapper/surveyDataMapper';
import CreateTemplateSubmissionErrors from '../submissionErrors/CreateTemplateSubmissionErrors';
import { TEMPLATE_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

export default (id, data = {}) => {
  const isSurvey = data.type_ === SURVEY_COMMON_TYPE;
  const dataMapper = isSurvey
    ? mapSurveyFromJsonApiModel
    : mapTemplateDataForEditor;
  return axios
    .post(buildApiV2Url(`${TEMPLATE_TYPE_COLLECTION_PATH}/${id}/clone`), data)
    .catch(
      generateApiError({
        submissionErrorMap: CreateTemplateSubmissionErrors,
      }),
    )
    .then(property('data'))
    .then(dataMapper);
};
